import React, { useContext, useEffect, useState } from "react";
import AdminHeader from "../../components/header";
import AdminSidebar from "../../components/sidebar";
import styles from "../../styles/admin.module.css";
import TableView from "../../components/table_view";
import {
  faBarChart,
  faCheck,
  faClipboard,
  faDownload,
  faEdit,
  faPenToSquare,
  faSpinner,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import axiosInstance from "../../../AxiosInstance";
// import myContext from "../../../MyContext";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../components/delete_modal/delete_modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatPrice } from "../../../utils/utils";
import {
  ToastTypes,
  toast,
} from "../../../components/ajonjolib/toasts/toast/toast";

export default function BillersList() {
  const [rows, setRows] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const navigate = useNavigate();
  const editObj = (data) => {
    navigate("/admin/billers/create", { state: data });
  };

  const stats = (data) => {
    navigate("/admin/biller/stats", { state: data });
  };

  const deleteObj = (id) => {
    axiosInstance.delete("supplier/" + id + "/").then((response) => {
      window.location.reload();
    });
  };
  const downloadPreviousMonthExcel = (id, name, commissionAmount) => {
    const currentDate = new Date();
    const previousMonth = currentDate.getMonth(); // 0-based index
    const year = currentDate.getFullYear();
    const month = previousMonth === 0 ? 12 : previousMonth;
    const currentYear = previousMonth === 0 ? year - 1 : year;

    axiosInstance
      .get(`supplier/${id}/excel/?month=${month}&year=${currentYear}`, {
        responseType: "blob",
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${name}-${month}-${currentYear}-commission-${formatPrice(
            commissionAmount
          )}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
      });
  };
  const copyToClipboard = async (data) => {
    const currentDate = new Date();
    const previousMonth = currentDate.getMonth(); // 0-based index
    const monthNames = [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre",
    ];
    const month = previousMonth === 0 ? 12 : previousMonth;
    const monthName = monthNames[month - 1];
    const year = currentDate.getFullYear();
    const currentYear = previousMonth === 0 ? year - 1 : year;

    try {
      const response = await axiosInstance.get(`supplier/${data.id}/stats/`);
      const salesData = response.data.sales_by_month;
      const total = salesData[month]?.total_sales || 0;
      const commissionAmount = total * (data.commission / 100);

      //       Avec les autres mois impayés ça fait  7900..
      // Pour payer votre commission, veuillez utiliser ce lien :
      // https://bringme.sn/payment/{data.last_payment_id}
      console.log(data.last_payment_total);
      const lastPayment = `Avec les autres mois impayés ça fait  ${formatPrice(
        data.last_payment_total
      )}\nPour payer votre commission, veuillez utiliser ce lien :\nhttps://bringme.sn/payment/${
        data.last_payment_id
      }`;

      // if data.last_payment_id ajout le text lastpayment dans text
      const text = `Bonjour ${
        data.name
      }, voici le point de vente du dernier mois :\n${monthName} ${currentYear} :  ${formatPrice(
        total
      )} F CFA, \nCommission : ${formatPrice(
        commissionAmount
      )} F CFA \nBonne réception ! ${data.last_payment_id ? lastPayment : ""}`;

      navigator.clipboard.writeText(text).then(
        () => {
          toast("Text copied to clipboard", ToastTypes.SUCCESS);
        },
        (err) => {
          console.error("Could not copy text: ", err);
        }
      );
    } catch (error) {
      console.error("Error fetching sales data:", error);
    }
  };

  const handleDownload = async (data) => {
    const currentDate = new Date();
    const previousMonth = currentDate.getMonth(); // 0-based index
    const year = currentDate.getFullYear();
    const month = previousMonth === 0 ? 12 : previousMonth;
    const currentYear = previousMonth === 0 ? year - 1 : year;

    try {
      const response = await axiosInstance.get(`c/supplier/${data.id}/stats/`);
      const salesData = response.data.sales_by_month;
      const commissionAmount = salesData[month]?.total_sales
        ? salesData[month].total_sales * (data.commission / 100)
        : 0;

      downloadPreviousMonthExcel(data.id, data.name, commissionAmount);
    } catch (error) {
      console.error("Error fetching sales data:", error);
    }
  };

  const [editingPointValue, setEditingPointValue] = useState("");
  const [editingPointId, setEditingPointId] = useState(null);
  const [changePointLoading, setChangePointloading] = useState({});
  const [loadingPoints, setLoadingPoints] = useState({});

  const handleChangePoints = (id, value) => {
    setChangePointloading((prev) => ({ ...prev, [id]: true })); // Démarrer le chargement

    // return console.log({ id, value });

    axiosInstance
      .post(`billers/${id}/update-points/`, {
        points: parseInt(value),
      })
      .then((response) => {
        if (response.status === 200) {
          toast("Modification réussie", ToastTypes.SUCCESS);
          // Met à jour l'état local sans recharger la page
          setRows((prevRows) =>
            prevRows?.map((row) =>
              row.id === id ? { ...row, points: value } : row
            )
          );
        } else {
          toast("Une erreur est survenue", ToastTypes.ERROR);
        }
      })
      .catch((error) => {
        toast("Error toggling points_enabled", ToastTypes.ERROR);
      })
      .finally(() => {
        setChangePointloading((prev) => ({ ...prev, [id]: false })); // Arrêter le chargement
      });
  };

  const togglePointsEnabled = (id, currentStatus) => {
    setLoadingPoints((prev) => ({ ...prev, [id]: true })); // Démarrer le chargement
    // return console.log({ id, currentStatus });
    axiosInstance
      .post(`billers/${id}/toggle-points-enabled/`, {
        is_enabled: !currentStatus,
      })
      .then((response) => {
        if (response.status === 200) {
          toast("Modification réussie", ToastTypes.SUCCESS);
          // Met à jour l'état local sans recharger la page
          setRows((prevRows) =>
            prevRows?.map((row) =>
              row.id === id ? { ...row, points_enabled: !currentStatus } : row
            )
          );
        } else {
          toast("Une erreur est survenue", ToastTypes.ERROR);
        }
      })
      .catch((error) => {
        toast("Error toggling points_enabled", ToastTypes.ERROR);
      })
      .finally(() => {
        setLoadingPoints((prev) => ({ ...prev, [id]: false })); // Arrêter le chargement
      });
  };

  const cols = [
    { title: "ID", internal: "id" },
    { title: "Image", code: (data) => (data.image ? "Oui" : "Non") },
    { title: "Name", internal: "name", filter: true },
    { title: "Description", internal: "description" },
    {
      title: "Active",
      internal: "active",
      isBoolean: true,
      // filter: true
    },
    {
      title: "Points",
      internal: "points",
      code: (data, row) => {
        const isEditing = editingPointId === data.id;

        return (
          <div className="d-flex align-items-center">
            {changePointLoading[data.id] ? ( // Afficher l'icône de chargement
              <FontAwesomeIcon icon={faSpinner} spin className="ms-2" />
            ) : isEditing ? (
              <>
                <input
                  type="text"
                  value={editingPointValue}
                  onChange={(e) => setEditingPointValue(e.target.value)}
                  onBlur={() => {
                    // Logique pour sauvegarder la modification
                    // Vous pouvez appeler une fonction pour mettre à jour les points ici
                  }}
                />
                <FontAwesomeIcon
                  icon={faCheck} // Remplacez par l'icône de validation
                  className="ms-2"
                  color="green"
                  onClick={() => {
                    // Logique pour sauvegarder la modification
                    // Vous pouvez appeler une fonction pour mettre à jour les points ici
                    handleChangePoints(data?.id, editingPointValue);
                    setEditingPointId(null);
                    setEditingPointValue("");
                  }}
                />
              </>
            ) : (
              <>
                <span>{data.points}</span>
                <FontAwesomeIcon
                  icon={faEdit}
                  className="ms-2"
                  color="orange"
                  onClick={() => {
                    setEditingPointId(data.id);
                    setEditingPointValue(data.points);
                  }}
                />
              </>
            )}
          </div>
        );
      },
    },
    {
      title: "Status Points",
      internal: "points",
      code: (data, row) => {
        return (
          <div className="d-flex align-items-center">
            <span> {data.points_enabled ? "Activé" : "Desactivé"}</span>

            <div className="form-check form-switch ms-2">
              {loadingPoints[data.id] ? ( // Afficher l'icône de chargement
                <FontAwesomeIcon icon={faSpinner} spin className="ms-2" />
              ) : (
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id={`flexSwitchCheck${data.id}`}
                  checked={data.points_enabled}
                  onChange={() =>
                    togglePointsEnabled(data.id, data.points_enabled)
                  }
                />
              )}
            </div>
          </div>
        );
      },
    },

    {
      title: "Month Sales",
      internal: "last_month_sales",
      code: (row, data) => (data ? formatPrice(data) : "0"),
    },

    {
      title: "Month Points",
      internal: "last_month_points_used",
      code: (row, data) => (data ? formatPrice(data) : "0"),
    },
    {
      title: "Commission",
      internal: "commission",
      code: (row, data) => {
        return row.commission + "%";
      },
    },
    {
      title: "Statut",
      internal: "payment_status",
      code: (row, data) => {
        if (row.last_month_sales === 0) {
          data = "Payé";
        }
        const color = data === "Payé" ? "#4CAF50" : "#EF4444";
        return <span style={{ color: color, fontWeight: "bold" }}>{data}</span>;
      },
      // filter: true
    },
    {
      title: "Actions",
      internal: "id",
      code: (data, row) => {
        return (
          <div className={"d-flex justify-content-end"}>
            <div
              role={"button"}
              onClick={() => editObj(data)}
              className={"pe-3"}
            >
              <FontAwesomeIcon icon={faPenToSquare} color={"#9EA3AC"} />
            </div>

            <div role={"button"} onClick={() => stats(data)} className={"pe-3"}>
              <FontAwesomeIcon icon={faBarChart} color={"#9EA3AC"} />
            </div>

            <div
              role={"button"}
              onClick={() => {
                setShowDelete(true);
                setSelectedId(row);
              }}
              className={"pe-3"}
            >
              <FontAwesomeIcon icon={faTrash} color={"#EF4444"} />
            </div>
            <div
              role={"button"}
              onClick={() => handleDownload(data)}
              className="pe-3"
            >
              <FontAwesomeIcon icon={faDownload} color={"#4CAF50"} />
            </div>
            <div role={"button"} onClick={() => copyToClipboard(data)}>
              <FontAwesomeIcon icon={faClipboard} color={"#00BFFF"} />
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className={styles.mainContainer}>
      <AdminHeader />
      <AdminSidebar />

      <DeleteModal
        show={showDelete}
        setter={setShowDelete}
        onClick={() => deleteObj(selectedId)}
      />

      <div className={`${styles.container} me-4 pb-4`}>
        <TableView
          fetchUrl={"c/supplier/simple"}
          defaultFilters={{ sale_info: true }}
          pull={setRows}
          title={"billers"}
          cols={cols}
          rows={rows}
          withIndex={true}
          limit={5}
          useReactQuery={"biller-list"}
        />
      </div>
    </div>
  );
}
